import {ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {Depot} from "../../../../shared/view-model/store-management/depot.type";
import {DepotService, FetchDepotsResult} from "../../../services/depot-service/depot.service";
import {ApolloQueryObservable} from "apollo-angular";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {AbstractVisbosControl} from "../../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {IModel} from "../../../../shared/view-model/imodel.interface";
import {appInjector} from "../../../../index";
import {StockService} from "../../../services/stock.service";
import {Stocktaking} from "../../../model/stocktaking";
import {StocktakingFormComponent} from "../stocktaking-form/stocktaking-form.component";
import * as Util from "util";

@Component({
  selector: 'vb-depot-stocktaking',
  templateUrl: './depot-stocktaking.component.html',
  styleUrls: ['./depot-stocktaking.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => DepotStocktakingComponent)}]
})
export class DepotStocktakingComponent extends AbstractVisbosControl<Stocktaking, FormGroup> implements OnInit, OnChanges {

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    super.ngOnInit();
  }


  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
  }

  public buildControlContent(values?: Stocktaking, ...params: any[]): FormGroup {
    return DepotStocktakingComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    let controls = StocktakingFormComponent.initControl(fb);
    controls.addControl('depot_id', new FormControl(null, Validators.required));

    return controls;

  }

  public setDefaultValues(item?: Stocktaking): { [controlKey: string]: any } | any {
    return {
      depot_id: this.setValue(item, 'depot.cuid')
    }
  };

}



// WEBPACK FOOTER //
// ./src/app/store-management/stocktaking/components/depot-stocktaking-form/depot-stocktaking.component.ts